import styled from "styled-components";

const MOBILE_BREAKPOINT = "768px";

export const MainContainer = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    align-items: flex-end;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        align-items: stretch;
    }
`;

export const Line = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(241, 241, 241, 0.85);
    margin-bottom: 10px;
`;

export const LeftSection = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const RightSection = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const HeaderContainer = styled.div`
    gap: 10px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        flex-direction: column;
        justify-content: flex-start;
        order: -1;
        margin-bottom: 16px;
    }
`;

export const BoxesContainer = styled.div`
    display: flex;
    gap: 16px;
`;

export const SubCompanyContainer = styled.div`
    flex-direction: column;
    display: flex;
    min-width: 250px;
    gap: 5px;
`;

export const DateRangeContainer = styled.div`
    flex-direction: column;
    display: flex;
    min-width: 250px;
    gap: 5px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        min-width: 100%;

        .ant-picker {
            width: 100%;
        }
    }
`;

export const TransactionTypeContainer = styled.div`
    flex-direction: column;
    display: flex;
    min-width: 225px;
    gap: 5px;

    @media (max-width: ${MOBILE_BREAKPOINT}) {
        min-width: 100%;
    }
`;

export const LoadContainer = styled.span`
    background-color: #00b894;
    padding: 5px;
    color: white;
    border-radius: 5px;
`;

export const UseContainer = styled.span`
    background-color: #ff5354;
    padding: 5px;
    color: white;
    border-radius: 5px;
`;

export const SubtypesMobileContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0;
    background-color: transparent;
`;

export const SubtypeMobileItem = styled.div`
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 12px;
    border: 1px solid #e8e8e8;
`;

export const SubtypeMobileRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    gap: 12px;

    &:first-child {
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 0;
    }

    &:not(:last-child) {
        border-bottom: 1px solid #e8e8e8;
    }

    strong {
        font-weight: 600;
        color: #333;
        font-size: 14px;
        flex-shrink: 0;
        min-width: 120px;
        max-width: 120px;
        display: block;
        line-height: 1.5;
    }

    span {
        text-align: left;
        font-size: 14px;
        word-wrap: break-word;
        overflow-wrap: break-word;
        word-break: normal;
        white-space: normal;
        line-height: 1.5;
        flex: 1;
        min-width: 0;
    }
`;

// Mirrors the load/use credit svg icons: lime circle top-left, black ring with the glyph offset over it
export const CashIconWrapper = styled.div`
    position: relative;
    width: 61px;
    height: 50px;
    flex-shrink: 0;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 39px;
        height: 39px;
        border-radius: 50%;
        background-color: #aeff01;
    }

    span {
        position: absolute;
        top: 7px;
        left: 18px;
        width: 43px;
        height: 43px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 3px solid #000;
        border-radius: 50%;
    }

    svg {
        width: 20px;
        height: 20px;
        color: #000;
    }
`;
